(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('ReporteEvaluativoRegularRegenerarService', ReporteEvaluativoRegularRegenerarService);

    ReporteEvaluativoRegularRegenerarService.$inject = ['$resource'];

    function ReporteEvaluativoRegularRegenerarService ($resource) {
        var resourceUrl =  'apo/reporteEvaluativo/regenerarreporteRegular:idA,:idP,:idAnio,:idIndice,:ic,:iic,:tipoEvaluacion,:idDependencia,:nivell,:modeloo';

        return $resource(resourceUrl, {}, {
        	'regenerar': {
            	method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
            	url:'apo/guardarreporteregularregenerar:id',
            	method:'PUT' 
            }
        });
    }
})();